﻿import {Fragment, JSX, ReactNode} from "react";
import {useFilteredItems} from "./FilteredItemsProvider";

interface FilteredItemsListProps<T> {
	keyExtractor: (item: T, index: number) => string | number;
	renderItem: (item: T) => ReactNode;
}

export function FilteredItemsList<T>({keyExtractor, renderItem}: FilteredItemsListProps<T>): JSX.Element {
	const {filtered} = useFilteredItems<T>();
	return (
		<>
			{filtered.map((item, index) => (
				<Fragment key={keyExtractor(item, index)}>
					{renderItem(item)}
				</Fragment>
			))}
		</>
	);
}
